import React, { useEffect, useState, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { FaEyeSlash } from 'react-icons/fa';
import base_url from './config/Config';
import Sidebar from './components/Sidebar';
import Navigation from './components/Navigation';
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import PageLoader from './components/PageLoader';

// import React, { useEffect, useState, useCallback } from 'react';
// import { NavLink } from 'react-router-dom';
// import { FaEyeSlash } from 'react-icons/fa';
// import base_url from './config/Config';
// import Sidebar from './components/Sidebar';
// import Navigation from './components/Navigation';
// import axios from "axios";
// import Spinner from 'react-bootstrap/Spinner'; // Import Spinner component

// const TodayRepayment = () => {
//     const [todayrepayment, setTodayRepayment] = useState([]);
//     const [isDownloading, setIsDownloading] = useState(false);
//       const [permissions, setPermissions] = useState([]);
//       const [currentPage, setCurrentPage] = useState(1);

//         const todayRepaymentPerPage = 50;

//     // const navigate = useNavigate();

//     //    Pemisiion privillages atart 
    
//          useEffect(() => {
//                 const adminId = localStorage.getItem('adminId') || '';
//                 axios.get(`${base_url}/api/auth/tabs/${adminId}`)
//                     .then(res => setPermissions(res.data || []))
//                     .catch(() => setPermissions([]));
//             }, []);
        
//             // Permission check helper
//             const hasPermission = useCallback((tabName, action) => {
//                 const tab = permissions.find(t => t.tabName === tabName);
//                 if (!tab) return false;
//                 switch (action) {
//                     case 'view': return !!tab.canView;
//                     case 'edit': return !!tab.canEdit;
//                     case 'download': return !!tab.canDelete; // using canDelete for download
//                     default: return false;
//                 }
//             }, [permissions]);
//     //    Pemisiion privillages end


//     // const getAllTodayRepayment = () => {
//     //      if (!hasPermission('Repayment', 'view')) return;
//     //     axios.get(`${base_url}/api/repayment/today`).then(
//     //         (response) => {
//     //             console.log(response.data);
//     //             setTodayRepayment(response.data);
//     //         },
//     //         (error) => {
//     //             console.log(error);
//     //         }
//     //     );

//     // };
//     const getAllTodayRepayment = useCallback(() => {
//     if (!hasPermission('Today Repayment', 'view')) return;
//     axios.get(`${base_url}/api/repayment/today`)
//         .then((response) => {
//             console.log(response.data);
//             setTodayRepayment(response.data);
//         })
//         .catch((error) => {
//             console.log(error);
//         });
// }, [hasPermission]); // 👈 add it here


//     // useEffect(() => {
//     //     getAllTodayRepayment();
//     // }, [],); // Empty dependency array to run only once on mount

//     useEffect(() => {
//     getAllTodayRepayment();
// }, [getAllTodayRepayment]);

//     // export excel function  start 
//     const handleExportTodayRepayment = async () => {
//           if (!hasPermission('Today Repayment', 'download')) {
//             alert('You do not have permission to download Today Repayment.');
//             return;
//         }
//         setIsDownloading(true);
//         try {
//             const response = await axios.get(`${base_url}/api/export/todayRepayment`, {
//                 responseType: 'blob' // This is important to handle binary data
//             });

//             // Create a link element
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'Today_Repayment_data.xlsx'); // Specify the file name here

//             // Append the link to the body
//             document.body.appendChild(link);

//             // Trigger the download
//             link.click();

//             // Remove the link from the document
//             document.body.removeChild(link);

//             console.log('Export Repayment successfully:', response.data);
//             alert('Export Repayment successfully');
//         } catch (error) {
//             console.error('Error generating repayment:', error.response?.data || error.message);
//             alert('Export Repayment not shown');
//         } finally {
//             setIsDownloading(false);
//         }
//     };




//     const indexOfLastTodayRepayment = currentPage * todayRepaymentPerPage;
//     const indexOfFirstTodayRepayment = indexOfLastTodayRepayment - todayRepaymentPerPage;
//     const todayRepayments = todayrepayment.slice(indexOfFirstTodayRepayment, indexOfLastTodayRepayment);
//     const totalPages = Math.ceil(todayrepayment.length / todayRepaymentPerPage);
//     const maxPageButtons = 10;

//     const getPaginationRange = () => {
//         const mid = Math.floor(maxPageButtons / 2);
//         let start = Math.max(1, currentPage - mid);
//         let end = Math.min(totalPages, start + maxPageButtons - 1);
//         if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
//         return { start, end };
//     };

//     const { start: startPage, end: endPage } = getPaginationRange();


      
//     if (!hasPermission('Today Repayment', 'view')) {
//         return (
//             <div className="text-center mt-5">
//                 <h3>Access Denied</h3>
//                 <p>You do not have permission to view this page.</p>
//             </div>
//         );
//     }


//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>Today Repayment</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms mt-5 text-center'>
//                             <div className='row'>
//                                 <div className='col-md-12'>
//                                     <div className='searchtoll'>
//                                         <form action="">
//                                             <div className='row'>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className=" required">
//                                                         <input type="hidden" name="approved" className="form-control" value="" />
//                                                         <select name="option" id="option" className="form-control" required="required">
//                                                             <option value="" selected="selected">Search By</option>
//                                                             <option value="branch">State</option>
//                                                             <option value="empolyee_id">Lender Name</option>
//                                                             <option value="empolyee_id">Clint Id</option>
//                                                             <option value="empolyee_id">Loan Id</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-3 col-6">
//                                                     <div className=" required">
//                                                         <input type="text" className="form-control" placeholder="Search..." required />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className=" required">
//                                                         <button type="submit" className="btn btn-sm btn-primary">Search</button>
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-6 mt-2'>
//                                                     <div className='export'>
//                                                         <NavLink to="#" className="exportbutton" onClick={handleExportTodayRepayment}
//                                                           disabled={isDownloading || !hasPermission('Today Repayment', 'download')}>
//                                                             {isDownloading ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>
//                                                                     Today Download
//                                                                 </>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                 </div>

//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 col-lg-12 mb-5 mt-3'>
//                                     <div className='allcustomer table-responsive table-striped'>
//                                         { pageLoading ? <PageLoader text="Loading..." /> : todayRepayments.length > 0  ? (
//                                             <table className="styled-table">
//                                                 <tbody>
//                                                     <tr>
//                                                         <th>S.N.</th>
//                                                         <th>Repayment_Id</th>
//                                                         <th>Loan_Id</th>
//                                                         <th>Customer_Id</th>
//                                                         <th>Customer_Name</th>
//                                                         <th>Phone_Number</th>
//                                                         <th>EMI_Due_Date</th>
//                                                         <th>EMI_Number</th>
//                                                         <th>EMI_Amount</th>
//                                                         <th>Principal</th>
//                                                         <th>Interest</th>
//                                                         <th>Create_Date</th>
//                                                         <th>Update_Date</th>
//                                                         <th>Status</th>
//                                                         <th>Action</th>
//                                                     </tr>
//                                                     {todayRepayments.map((data, index) => {
//                                                         const repayment = data.repayment; // nested object
//                                                         return (
//                                                             <tr key={index}>
//                                                                 <td>{index + 1 + (currentPage - 1) * todayRepaymentPerPage}</td>
//                                                                 <td>{repayment.id}</td>
//                                                                 <td>{repayment.loanId}</td>
//                                                                 <td>{repayment.customerId}</td>
//                                                                 <td>{data.customerName}</td>
//                                                                 <td>{data.phoneNumber}</td>
//                                                                 <td>{repayment.installmentDate}</td>
//                                                                 <td>{repayment.installmentNumber}</td>
//                                                                 <td>{repayment.emiAmount}</td>
//                                                                 <td>{repayment.principal}</td>
//                                                                 <td>{repayment.interest}</td>
//                                                                 <td>{repayment.createDate ? new Date(repayment.createDate).toLocaleDateString() : ''}</td>
//                                                                 <td>{repayment.updateDate ? new Date(repayment.updateDate).toLocaleDateString() : ''}</td>
//                                                                 <td style={{
//                                                                     color: repayment.emiStatus === 1 ? 'green' : repayment.emiStatus === 0 ? 'black' : 'red',
//                                                                     fontWeight: '700'
//                                                                 }}>
//                                                                     {repayment.emiStatus === 0 ? 'Pending' : repayment.emiStatus === 1 ? 'Paid' : 'Unknown'}
//                                                                 </td>
//                                                                 <td className='iconss'>
//                                                                       {hasPermission('Today Repayment', 'view') ? (
//                                                                     <NavLink to={`/loanmaster/ViewLoan?customerId=${repayment.customerId}&loanId=${repayment.loanId}`}>
//                                                                         <FaEyeSlash />
//                                                                     </NavLink>
//                                                                     ) : (
//                                                                  <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
//                                                                   )}
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })}

//                                                 </tbody>

//                                             </table>
//                                         ) : (
//                                             "No Emi Due Today Repayment"
//                                         )}
//                                     </div>
//                                     <div className="pagination-container">
//                                         <div className="pagination-box">
//                                             {startPage > 1 && (
//                                                 <>
//                                                     <button onClick={() => setCurrentPage(1)}>1</button>
//                                                     <span className="dots">...</span>
//                                                 </>
//                                             )}
//                                             {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
//                                                 <button
//                                                     key={startPage + i}
//                                                     className={currentPage === startPage + i ? 'active' : ''}
//                                                     onClick={() => setCurrentPage(startPage + i)}
//                                                 >
//                                                     {startPage + i}
//                                                 </button>
//                                             ))}
//                                             {endPage < totalPages && (
//                                                 <>
//                                                     <span className="dots">...</span>
//                                                     <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default TodayRepayment;



const TodayRepayment = () => {
    const [todayrepayment, setTodayRepayment] = useState([]);
    const [filteredRepayment, setFilteredRepayment] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const todayRepaymentPerPage = 50;

    // Permissions
    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]))
            .finally(() => setPageLoading(false));
    }, []);

    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete; // using canDelete for download
            default: return false;
        }
    }, [permissions]);

    // Fetch all today repayments
    const getAllTodayRepayment = useCallback(() => {
        if (!hasPermission('Today Repayment', 'view')) return;
        setPageLoading(true);
        axios.get(`${base_url}/api/repayment/today`)
            .then((response) => {
                console.log(response.data);
                setTodayRepayment(response.data);
                setFilteredRepayment(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => setPageLoading(false));
    }, [hasPermission]);

    useEffect(() => {
        getAllTodayRepayment();
    }, [getAllTodayRepayment]);

    // Export excel
    const handleExportTodayRepayment = async () => {
        if (!hasPermission('Today Repayment', 'download')) {
            alert('You do not have permission to download Today Repayment.');
            return;
        }
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api/export/todayRepayment`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Today_Repayment_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert('Export successful!');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export failed');
        } finally {
            setIsDownloading(false);
        }
    };

    // ✅ Search Filter Logic (same as your repayment page)
    const handleSearch = (event) => {
        event.preventDefault();
        let filtered = [...todayrepayment];

        if (searchOption && searchInput) {
            switch (searchOption) {
                case 'borrower_name':
                    filtered = filtered.filter(item =>
                        item.customerName?.toLowerCase().includes(searchInput.toLowerCase())
                    );
                    break;
                case 'loan_id':
                    filtered = filtered.filter(item =>
                        item.repayment.loanId?.toString() === searchInput
                    );
                    break;
                case 'customer_id':
                    filtered = filtered.filter(item =>
                        item.repayment.customerId?.toString() === searchInput
                    );
                    break;
                case 'phone':
                    filtered = filtered.filter(item =>
                        item.phoneNumber?.toString().includes(searchInput)
                    );
                    break;
                default:
                    break;
            }
        }

        setFilteredRepayment(filtered);
        setCurrentPage(1);
    };

    // Pagination
    const indexOfLast = currentPage * todayRepaymentPerPage;
    const indexOfFirst = indexOfLast - todayRepaymentPerPage;
    const currentRepayments = filteredRepayment.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredRepayment.length / todayRepaymentPerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();

    if (pageLoading) return <PageLoader text="Loading Today Repayment..." />;

    if (!hasPermission('Today Repayment', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return (
        <>
            <div className='overviewsaa'>
                <h4>Today Repayment</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3">
                                                    <select
                                                        className="form-control"
                                                        value={searchOption}
                                                        onChange={(e) => setSearchOption(e.target.value)}
                                                    >
                                                        <option value="">Search By</option>
                                                        <option value="borrower_name">Borrower Name</option>
                                                        <option value="loan_id">Loan ID</option>
                                                        <option value="customer_id">Customer ID</option>
                                                        <option value="phone">Phone Number</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-4">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                </div>
                                                <div className='col-md-3 mt-2'>
                                                    <div className='export'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportTodayRepayment}
                                                            disabled={isDownloading || !hasPermission('Today Repayment', 'download')}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>Today Download</>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-2 mt-2'>
                                    <div className='allcustomer table-responsive table-striped'>
                                        {currentRepayments.length > 0 ? (
                                            <table className="styled-table">
                                                <tbody>
                                                    <tr>
                                                        <th>S.N.</th>
                                                        <th>Repayment_Id</th>
                                                        <th>Loan_Id</th>
                                                        <th>Customer_Id</th>
                                                        <th>Customer_Name</th>
                                                        <th>Phone_Number</th>
                                                        <th>EMI_Due_Date</th>
                                                        <th>EMI_Number</th>
                                                        <th>EMI_Amount</th>
                                                        <th>Principal</th>
                                                        <th>Interest</th>
                                                        <th>Create_Date</th>
                                                        <th>Update_Date</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {currentRepayments.map((data, index) => {
                                                        const repayment = data.repayment;
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1 + (currentPage - 1) * todayRepaymentPerPage}</td>
                                                                <td>{repayment.id}</td>
                                                                <td>{repayment.loanId}</td>
                                                                <td>{repayment.customerId}</td>
                                                                <td>{data.customerName}</td>
                                                                <td>{data.phoneNumber}</td>
                                                                <td>{repayment.installmentDate}</td>
                                                                <td>{repayment.installmentNumber}</td>
                                                                <td>{repayment.emiAmount}</td>
                                                                <td>{repayment.principal}</td>
                                                                <td>{repayment.interest}</td>
                                                                <td>{repayment.createDate ? new Date(repayment.createDate).toLocaleDateString() : ''}</td>
                                                                <td>{repayment.updateDate ? new Date(repayment.updateDate).toLocaleDateString() : ''}</td>
                                                                <td style={{
                                                                    color: repayment.emiStatus === 1 ? 'green' : repayment.emiStatus === 0 ? 'black' : 'red',
                                                                    fontWeight: '700'
                                                                }}>
                                                                    {repayment.emiStatus === 0 ? 'Pending' : repayment.emiStatus === 1 ? 'Paid' : 'Unknown'}
                                                                </td>
                                                                <td className='iconss'>
                                                                    {hasPermission('Today Repayment', 'view') ? (
                                                                        <NavLink to={`/loanmaster/ViewLoan?customerId=${repayment.customerId}&loanId=${repayment.loanId}`}>
                                                                            <FaEyeSlash />
                                                                        </NavLink>
                                                                    ) : (
                                                                        <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No EMI Due Today"
                                        )}
                                    </div>

                                    {/* Pagination */}
                                    <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TodayRepayment;

